import request from '@/utils/workFlowRequest'
import constants from '@/utils/constants'
const ProcessDefinitionService = {
  state: {},

  mutations: {},

  actions: {
    /**
     * 查询当前用户待办任务
     */
    getCurrentUserTaskWaitByPage({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get(constants.WORKFLOW + 'workflowTask/getCurrentUserTaskWaitByPage', params).then(response => {
          const data = response
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * 查询当前用户完成任务
     */
    getCurrentUserTaskFinishByPage({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get(constants.WORKFLOW + 'workflowTask/getCurrentUserTaskFinishByPage', params).then(response => {
          const data = response
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * 查询所有用户的待办任务
     */
    getAllTaskWaitByPage({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get(constants.WORKFLOW + 'workflowTask/getAllTaskWaitByPage', params).then(response => {
          const data = response
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * 查询所有用户的已办任务
     */
    getAllTaskFinishByPage({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get(constants.WORKFLOW + 'workflowTask/getAllTaskFinishByPage', params).then(response => {
          const data = response
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },

    /**
     * 提交工单审批
     */
    submitWorkOrderApproval({ commit }, processId) {
      return new Promise((resolve, reject) => {
        request.post(constants.WORKFLOW + 'workflowTask/submitApproval', processId).then(response => {
          const data = response
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * 完成任务
     */
    workflowTaskCompleteTask({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.post(constants.WORKFLOW + 'workflowTask/completeTask', params).then(response => {
          const data = response
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}

export default ProcessDefinitionService
